import { render, staticRenderFns } from "./ResourceTopMsg.vue?vue&type=template&id=837ad7be&scoped=true&"
import script from "./ResourceTopMsg.vue?vue&type=script&lang=js&"
export * from "./ResourceTopMsg.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTopMsg.vue?vue&type=style&index=0&id=837ad7be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ad7be",
  null
  
)

export default component.exports